import { BadgeStatusColor } from '@/components/BadgeStatus';

const folderStatusToColor = [
  { key: 'FOLDER_STATUS_AUTHORITIE_CONTROL_INCIDENT', level: BadgeStatusColor.HIGH },
  { key: 'FOLDER_STATUS_INCIDENT', level: BadgeStatusColor.HIGH },
  { key: 'FOLDER_STATUS_PENDING_ORDER', level: BadgeStatusColor.MEDIUM },
  { key: 'FOLDER_STATUS_READY_FOR_CROSSING', level: BadgeStatusColor.LOW },
  { key: 'FOLDER_STATUS_FOLDER_CLOSED', level: BadgeStatusColor.LOW },
  { key: 'FOLDER_STATUS_CUSTOM_STATUS_GREEN', level: BadgeStatusColor.LOW },
  { key: 'FOLDER_STATUS_CUSTOMS_FORMALITIES_READY', level: BadgeStatusColor.MEDIUM },
  { key: 'FOLDER_STATUS_CUSTOM_STATUS_ORANGE', level: BadgeStatusColor.MEDIUM },
  { key: 'FOLDER_STATUS_PENDING_REQUEST', level: BadgeStatusColor.MEDIUM },
  { key: 'FOLDER_STATUS_EXPIRED_REQUEST', level: BadgeStatusColor.HIGH },
  { key: 'FOLDER_STATUS_EXPIRED_ORDER', level: BadgeStatusColor.HIGH },
  { key: 'FOLDER_STATUS_CANCELLED_REQUEST', level: BadgeStatusColor.HIGH },
  { key: 'FOLDER_STATUS_CANCELLED_ORDER', level: BadgeStatusColor.HIGH },
  { key: 'FOLDER_STATUS_DOCUMENTARY_INCIDENT', level: BadgeStatusColor.HIGH },
  { key: 'FOLDER_STATUS_DOCUMENTARY_INCIDENT_TREATED', level: BadgeStatusColor.HIGH },
  { key: 'FOLDER_STATUS_AUTHORITIE_CONTROL_INCIDENT', level: BadgeStatusColor.HIGH },
  { key: 'FOLDER_STATUS_CREATED_CROSSING_DOCUMENTS', level: BadgeStatusColor.LOW },
  { key: 'FOLDER_STATUS_OBSOLETE_CROSSING_DOCUMENTS', level: BadgeStatusColor.HIGH },
  { key: 'VEHICLE_STATUS_LOADING_VEHICLE', level: BadgeStatusColor.LOW },
  { key: 'VEHICLE_STATUS_GREEN_CUSTOMS_STATUS', level: BadgeStatusColor.LOW },
  { key: 'VEHICLE_STATUS_ORANGE_CUSTOMS_STATUS', level: BadgeStatusColor.MEDIUM },
  { key: 'VEHICLE_STATUS_AUTHORITIES_INSPECTION_INCIDENT', level: BadgeStatusColor.HIGH },
  { key: 'FOLDER_STATUS_BILLING_CHECK', level: BadgeStatusColor.LOW },

  { key: 'BORDER_CROSSING_RORO.FOLDER_STATUS_PENDING_REQUEST', level: BadgeStatusColor.MEDIUM },
  { key: 'BORDER_CROSSING_RORO.FOLDER_STATUS_EXPIRED_REQUEST', level: BadgeStatusColor.HIGH },
  { key: 'BORDER_CROSSING_RORO.FOLDER_STATUS_CANCELLED_REQUEST', level: BadgeStatusColor.HIGH },
  { key: 'BORDER_CROSSING_RORO.FOLDER_STATUS_PENDING_ORDER', level: BadgeStatusColor.MEDIUM },
  { key: 'BORDER_CROSSING_RORO.FOLDER_STATUS_CANCELLED_ORDER', level: BadgeStatusColor.HIGH },
  { key: 'BORDER_CROSSING_RORO.FOLDER_STATUS_EXPIRED_ORDER', level: BadgeStatusColor.HIGH },
  { key: 'BORDER_CROSSING_RORO.FOLDER_STATUS_DOCUMENTARY_INCIDENT', level: BadgeStatusColor.HIGH },
  { key: 'BORDER_CROSSING_RORO.FOLDER_STATUS_DOCUMENTARY_INCIDENT_TREATED', level: BadgeStatusColor.HIGH },
  { key: 'BORDER_CROSSING_RORO.FOLDER_STATUS_CREATED_CROSSING_DOCUMENTS', level: BadgeStatusColor.LOW },
  { key: 'BORDER_CROSSING_RORO.FOLDER_STATUS_OBSOLETE_CROSSING_DOCUMENTS', level: BadgeStatusColor.HIGH },
  { key: 'BORDER_CROSSING_RORO.FOLDER_STATUS_BILLING_CHECK', level: BadgeStatusColor.LOW },
  { key: 'BORDER_CROSSING_RORO.FOLDER_STATUS_FOLDER_CLOSED', level: BadgeStatusColor.LOW },

  { key: 'BORDER_CROSSING_RORO_EMPTY_V2.FOLDER_STATUS_PENDING_REQUEST', level: BadgeStatusColor.MEDIUM },
  { key: 'BORDER_CROSSING_RORO_EMPTY_V2.FOLDER_STATUS_EXPIRED_REQUEST', level: BadgeStatusColor.HIGH },
  { key: 'BORDER_CROSSING_RORO_EMPTY_V2.FOLDER_STATUS_CANCELLED_REQUEST', level: BadgeStatusColor.HIGH },
  { key: 'BORDER_CROSSING_RORO_EMPTY_V2.FOLDER_STATUS_PENDING_ORDER', level: BadgeStatusColor.MEDIUM },
  { key: 'BORDER_CROSSING_RORO_EMPTY_V2.FOLDER_STATUS_CANCELLED_ORDER', level: BadgeStatusColor.HIGH },
  { key: 'BORDER_CROSSING_RORO_EMPTY_V2.FOLDER_STATUS_EXPIRED_ORDER', level: BadgeStatusColor.HIGH },
  { key: 'BORDER_CROSSING_RORO_EMPTY_V2.FOLDER_STATUS_DOCUMENTARY_INCIDENT', level: BadgeStatusColor.HIGH },
  { key: 'BORDER_CROSSING_RORO_EMPTY_V2.FOLDER_STATUS_DOCUMENTARY_INCIDENT_TREATED', level: BadgeStatusColor.HIGH },
  { key: 'BORDER_CROSSING_RORO_EMPTY_V2.FOLDER_STATUS_CREATED_CROSSING_DOCUMENTS', level: BadgeStatusColor.LOW },
  { key: 'BORDER_CROSSING_RORO_EMPTY_V2.FOLDER_STATUS_OBSOLETE_CROSSING_DOCUMENTS', level: BadgeStatusColor.HIGH },
  { key: 'BORDER_CROSSING_RORO_EMPTY_V2.FOLDER_STATUS_BILLING_CHECK', level: BadgeStatusColor.LOW },
  { key: 'BORDER_CROSSING_RORO_EMPTY_V2.FOLDER_STATUS_FOLDER_CLOSED', level: BadgeStatusColor.LOW },
];

export const getFolderStatusLevelByKey = (folderStatusKey: string) =>
  folderStatusToColor.find((status) => status.key === folderStatusKey)?.level ?? BadgeStatusColor.NONE;
